import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/sbt-panel-7391", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/sbt-panel-7391", { replace: true });
    else setError(res.error);
  };

  const input = "w-full bg-obsidian border border-white/15 rounded-lg px-4 py-3 text-sm text-ink focus:border-copper transition-colors";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-4">
      <form data-testid="admin-login-form" onSubmit={submit} className="card-surface p-8 w-full max-w-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-copper/15 flex items-center justify-center"><Lock className="text-copper" size={18} /></div>
          <div>
            <p className="font-display text-xl font-bold uppercase text-ink">Sıfır Bir CMS</p>
            <p className="text-xs text-faint">Admin Panel</p>
          </div>
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2 mb-4">{error}</p>}
        <label className="block text-xs text-subtle mb-1.5">Email</label>
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${input} mb-4`} />
        <label className="block text-xs text-subtle mb-1.5">Password</label>
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${input} mb-6`} />
        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-copper w-full disabled:opacity-60">
          {loading ? "…" : "Login"}
        </button>
      </form>
    </div>
  );
}
